"use strict";

exports.__esModule = true;
exports.default = void 0;

var range = function range(min, max) {
  var years = Array(max - min + 1).fill(min);
  return years.map(function (year, i) {
    return year + i;
  });
};

var _default = range;
exports.default = _default;